export default "__VITE_ASSET__DjwKWCvi__"